<template>
  <div class="index">
    <div class="header_lunbotu">
      <h3 class="centre">精致与实用本不矛盾</h3>
      <img class="ban" src="../../assets/images/首页切图/首图/板2.png" alt="">
      <canvas id="canvas" width="1000" height="500"></canvas>
      <img class="block_1" src="../../assets/images/首页切图/首图/方块1.png" alt="" />
      <img class="block_2" src="../../assets/images/首页切图/首图/方块2.png" alt="" />
      <img class="circle_1" src="../../assets/images/首页切图/首图/圆点.png" alt="" />
      <img class="circle_2" src="../../assets/images/首页切图/首图/圆点2.png" alt="" />
      <img class="circle_3" src="../../assets/images/首页切图/首图/圆点2.png" alt="" />
      <!-- <img class="meteor_1" src="../../assets/images/首页切图/首图/流星1.png" alt=""/>
      <img class="meteor_2" src="../../assets/images/首页切图/首图/流星2.png" alt=""/> -->
      <div class="star_box">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
      </div>
    </div>
    <div class="index_main1">
      <img class="bottom_img" src="../../assets/images/首页切图/电子证书/电子证书bg.png" alt="">
      <div class="centre heder-bottom">
        <ul>
          <li>
            <div class="heder-bottom-l">
              <img src="../../assets/images/首页切图/电子证书/多边形545.png" alt="">
              <img class="center_img" style="top: -80px;left: 13px;" src="../../assets/images/首页切图/电子证书/技术-line.png"
                alt="" />
            </div>
            <div class="heder-bottom-r">
              <Counto class="date-1" :startVal='startVal' :endVal='endVal1' :duration='5000'></Counto>
              <i>+</i>
              <h3>拥有数十项软件著作权</h3>
            </div>
          </li>
          <li>
            <div class="heder-bottom-l">
              <img src="../../assets/images/首页切图/电子证书/多边形545.png" alt="">
              <img class="center_img" style="top: -80px;" src="../../assets/images/首页切图/电子证书/PropertySafetyFilled.png"
                alt="">
            </div>
            <div class="heder-bottom-r">
              <Counto class="date-1" :startVal='startVal' :endVal='endVal2' :duration='4000'></Counto>
              <i>+</i>
              <h3>成功服务于众多客户</h3>
            </div>
          </li>
          <li>
            <div class="heder-bottom-l">
              <img src="../../assets/images/首页切图/电子证书/多边形545.png" alt="">
              <img class="center_img" style="top: -80px;left: 16px;" src="../../assets/images/首页切图/电子证书/结构.png" alt="">
            </div>
            <div class="heder-bottom-r">
              <Counto class="date-1" :startVal='startVal' :endVal='endVal3' :duration='7000'></Counto>
              <i>+</i>
              <h3>丰富的开发和项目管理经验</h3>
            </div>
          </li>
        </ul>
      </div>
      <div class="main_b centre">
        <div class="main_bimg">
          <img class="back_clrcle" src="../../assets/images/首页切图/首页图形动效/组31.png" alt="">
          <img class="diban" src="../../assets/images/首页切图/首页图形动效/首页电子证书/底板.png" alt="" />
          <img class="houban" src="../../assets/images/首页切图/首页图形动效/首页电子证书/组31.png" alt="" />
          <!-- <img class="shuzhi" src="../../assets/images/首页切图/首页图形动效/首页电子证书/竖着的板.png" alt=""/> -->
          <!-- <img class="main_img" src="../../assets/images/首页切图/首页图形动效/底图.png" alt= ""/> -->
          <img class="mainblock_1" src="../../assets/images/首页切图/首页图形动效/组26拷贝.png" alt="" />
          <img class="mainblock_2" src="../../assets/images/首页切图/首页图形动效/组26.png" alt="" />
          <img class="paper" src="../../assets/images/首页切图/首页图形动效/首页电子证书/消失纸.png" alt="" />
          <img class="zhezhao" src="../../assets/images/首页切图/首页图形动效/首页电子证书/组32.png" alt="" />

          <!-- <img class="paper_1" src="../../assets/images/首页切图/首页图形动效/组27.png" alt=""/> -->
          <!-- <img style="height: 430px;width:430px;" src="../../assets/images/首页切图/电子证书/电子证书图.png" alt=""> -->
        </div>
        <div class="main_btext">
          <h3>域贝证书宝</h3>
          <div class="btext">
            <p>
              域贝证书宝系统实现了企事业单位、组织机构、社会团体等颁发电子证书的全生命周期管理，包括证书的批量制作发放、防伪溯源、查询验证、数据分析等一系列功能。
            </p>
            <el-button
              @click="() => { this.$router.push('/productservice'); this.$store.commit('saveIndex', 1) }">查看更多</el-button>
          </div>
          <!-- <img  src="../../assets/images/首页切图/方块.png" alt=""> -->
        </div>
      </div>
      <!-- <img class="zheng" src="../../assets/images/首页切图/方块.png" alt=""> -->
    </div>

    <div class="index_main2">
      <div class="centre">
        <div class="main2-center">
          <h3>域贝一体化平台</h3>
          <p>信息化数字化底座系统，解决应用孤岛问题，让应用互联互通，形成数据合力。</p>
          <el-button
            @click="() => { this.$router.push('/integrated'); this.$store.commit('saveIndex', 2) }">查看更多</el-button>
        </div>
        <ul>
          <li>
            <div class="main2-img">
              <img class="amin2-img-top" style="margin-left: 5px;margin-top: -10px;"
                src="../../assets/images/首页切图/一体化/账号.png" alt="">
              <img src="../../assets/images/首页切图/一体化/一体化平台底盘.png" alt="">
            </div>
            <p>账号一体化</p>
          </li>
          <li>
            <div class="main2-img">
              <img class="amin2-img-top" style="margin-left: -4px;margin-top: -10px;"
                src="../../assets/images/首页切图/一体化/管理.png" alt="">
              <img src="../../assets/images/首页切图/一体化/一体化平台底盘.png" alt="">
            </div>
            <p>管理一体化</p>
          </li>
          <li>
            <div class="main2-img">
              <img class="amin2-img-top" style="margin-left: -4px;margin-top: -10px;"
                src="../../assets/images/首页切图/一体化/应用.png" alt="">
              <img src="../../assets/images/首页切图/一体化/一体化平台底盘.png" alt="">
            </div>
            <p>应用一体化</p>
          </li>
          <li>
            <div class="main2-img">
              <img class="amin2-img-top" style="margin-top: -18px;" src="../../assets/images/首页切图/一体化/数据.png" alt="">
              <img src="../../assets/images/首页切图/一体化/一体化平台底盘.png" alt="">
            </div>
            <p>数据一体化</p>
          </li>
          <li>
            <div class="main2-img">
              <img class="amin2-img-top" style="margin-top: -10px;" src="../../assets/images/首页切图/一体化/服务.png" alt="">
              <img src="../../assets/images/首页切图/一体化/一体化平台底盘.png" alt="">
            </div>
            <p>服务一体化</p>
          </li>
        </ul>

      </div>
    </div>

    <div class="centre index_main3">
      <div class="main3-l">
        <h3>域贝大数据平台</h3>
        <div class="btext">
          <p>以第三代瑶池数据仓库为数据存储核心，实现了数据汇集，治理，资产，分析，服务，应用服务等数据全流程全生命周期大数据平台。 </p>
          <el-button @click="() => { this.$router.push('/date'); this.$store.commit('saveIndex', 3) }">查看更多</el-button>
        </div>
      </div>
      <div class="main3-r">
        <img class="back" src="../../assets/images/首页切图/首页图形动效/未标题-99.gif" alt="">
        <img class="bottom" src="../../assets/images/首页切图/首页图形动效/组29.png" alt="">
        <img class="bottom_block" src="../../assets/images/首页切图/首页图形动效/方线条.png" alt="">
        <!-- <div class="move_box"></div> -->
        <img class="bottom_circle" src="../../assets/images/首页切图/首页图形动效/椭圆2.png" alt="">
        <img class="big_circle" src="../../assets/images/首页切图/首页图形动效/大圈.png" alt="" />
        <img class="big_cloud" src="../../assets/images/首页切图/首页图形动效/组28.png" alt="" />
        <!-- <img style="height:405px;margin-left:50px;margin-top: 80px;" src="../../assets/images/首页切图/大数据/lQLPJxZbP5bs7s_NAjrNAqCwKzWiM7tY0yAClpFThkCdAQ_672_570.png" alt=""> -->
      </div>
    </div>
    <div class="centre index_main4">
      <div class="main4-l">
        <h3>创新的可视化操作</h3>
        <p>lnnovative Visual Operaticn</p>
        <div class="content_1">
          <p>海量、异构、全域的数据汇聚可视化操控，支持数据源一键接入</p>
        </div>
        <img style="height: 75px;width: 90px;" src="../../assets/images/首页切图/大数据/创新.png" alt="" />
      </div>
      <div class="main4-r">
        <ul>
          <li class="main-centre" @mouseenter="">
            <h3>安全高效的数据共享</h3>
            <p class="main-centre-p">Secure And Efhclent Date Sharing</p>
            <div class="main4-img" style=" margin-left: 214px; margin-top: 50px;">
              <img style="height: 70px;" src="../../assets/images/首页切图/大数据/安全.png" alt="">
            </div>
            <div class="main4-text">
              <p class="main4-text-1">支持数据批量推拉，数据订阅等</p>
              <p>多种安全高效的数据共享方式</p>
            </div>
          </li>
          <li class="main-centre-right">
            <h3>优异的数据搜索能力</h3>
            <p class="main-centre-p">Excellent Date Search Skills</p>
            <div class="main4-img" style=" margin-left: 204px; margin-top: 45px;">
              <img src="../../assets/images/首页切图/大数据/优异.png" alt="">
            </div>
            <div class="main4-text">
              <p class="main4-text-1">基于全文搜索引擎Lucense，提供强大</p>
              <p>的实时流处理和数据检索动力</p>
            </div>
          </li>
          <li class="main-centre">
            <h3>资产化的监控运维</h3>
            <p class="main-centre-p">Assets Monitoring Operation And Maintenance</p>
            <div class="main4-img" style=" margin-left: 215px; margin-top: 45px;">
              <img style="height: 67px;" src="../../assets/images/首页切图/大数据/资产化.png" alt="">
            </div>
            <div class="main4-text">
              <p class="main4-text-1">便捷的数据质量全生命周期实时监</p>
              <p>控，以资产管理模式来运维数据</p>
            </div>
          </li>
          <li class="main-centre-right">
            <h3>灵活的数据应用能力</h3>
            <p class="main-centre-p">Flexible Date Application Caoabillty</p>
            <div class="main4-img" style=" margin-left: 215px; margin-top: 45px;">
              <img style="height: 67px;" src="../../assets/images/首页切图/大数据/灵活.png" alt="">
            </div>
            <div class="main4-text">
              <p class="main4-text-1">利用数据运算以及丰富的服务接口，</p>
              <p>赋能数据应用场景化需求</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="centre index_main5">
        <div class="index_main5-l">
          <h3>解决方案</h3>
          <p>The Solution</p>
        </div>
        <div class="index_main5-r">
          <ul class="index_main5-r-1" v-for="(item, index) in list" :key="index">
            <li :class="[index === liIndex ? 'li_2' : 'li_1']" @click="clickadmin5(item)">
              <div class="tlite">{{ item.tlite }}</div>
              <div class="text">{{ item.text }}</div>
            </li>
          </ul>
          <el-button>查看更多</el-button>
          <div class="main-center" :style="{ display: istrue === '01' ? 'block' : 'none' }">
            <h4>政企数字一体化平台解决方案</h4>
            <p>客户案例</p>
            <ul class="main5-r-center-1">
              <li @mouseenter="showImg(1)" @mouseleave="showImg2(1)">
                <div class="main5-r-img">
                  <img style="height: 28px;margin-top: 5px;" v-show="whiteShow1"
                    src="../../assets/images/首页切图/解决方案/white.png" alt="" />
                  <img style="height: 28px;margin-top: 5px;" v-show="!whiteShow1"
                    src="../../assets/images/首页切图/解决方案/图层531.png" alt="" />
                </div>
                <p style="margin-top: 28px;">温州市城市建设发展集团有限公司(温州城发)</p>
              </li>
              <li @mouseenter="showImg(2)" @mouseleave="showImg2(2)">
                <div class="main5-r-img">
                  <img style="height: 28px;margin-top: 5px;" v-show="whiteShow2"
                    src="../../assets/images/首页切图/解决方案/white.png" alt="" />
                  <img style="height: 28px;margin-top: 5px;" v-show="!whiteShow2"
                    src="../../assets/images/首页切图/解决方案/图层531.png" alt="" />
                </div>
                <p style="margin-top: 28px;">温州市数据管理发展集团有限公司(温州数发)</p>
              </li>
              <li @mouseenter="showImg(3)" @mouseleave="showImg2(3)">
                <div class="main5-r-img">
                  <img style="height: 28px;margin-top: 5px;" v-show="whiteShow3"
                    src="../../assets/images/首页切图/解决方案/white.png" alt="" />
                  <img style="height: 28px;margin-top: 5px;" v-show="!whiteShow3"
                    src="../../assets/images/首页切图/解决方案/图层531.png" alt="" />
                </div>
                <p style="margin-top: 28px;">温州市教育投资集团有限公司(温州教投)</p>
              </li>
              <li @mouseenter="showImg(4)" @mouseleave="showImg2(4)">
                <div class="main5-r-img">
                  <img style="height: 28px;margin-top: 5px;" v-show="whiteShow4"
                    src="../../assets/images/首页切图/解决方案/white.png" alt="" />
                  <img style="height: 28px;margin-top: 5px;" v-show="!whiteShow4"
                    src="../../assets/images/首页切图/解决方案/图层531.png" alt="" />
                </div>
                <p style="margin-top: 28px;">温州市市政工程建设开发有限公司</p>
              </li>
              <li>
                <div class="main5-r-img">
                  <img src="../../assets/images/首页切图/解决方案/图层529.png" alt="" />
                </div>
                <p>温州日报报业集团有限公司</p>
              </li>
              <li @mouseenter="showImg(6)" @mouseleave="showImg2(6)">
                <div class="main5-r-img">
                  <img data-v-1203724d="" v-show="!whiteShow6"
                    src="data:image/png;base64,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"
                    alt="">
                  <img data-v-1203724d="" v-show="whiteShow6"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAlCAYAAADfosCNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzI5QzdFMUFFRTRDMTFFQzgzOTJDMDhEQkIwMENGRTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzI5QzdFMUJFRTRDMTFFQzgzOTJDMDhEQkIwMENGRTYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozMjlDN0UxOEVFNEMxMUVDODM5MkMwOERCQjAwQ0ZFNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozMjlDN0UxOUVFNEMxMUVDODM5MkMwOERCQjAwQ0ZFNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlHhwfIAAAMXSURBVHjaxNh9aE1hHMDxe+82eynSWEN5KX8oRCkv4R8pb7GwJS9F2xriH/IWkaSkUJTmDyIv/4g/vCTULGQslhrmDyb7Q6J2d83bbGzX9+F3dJ3OeZ57zz33nl99tjrn3uf87nOe5zm/84Tj8fjGUCh0GR9D/8dA7EYVCtGFeCizEcVD1OLxv6Mk+RPvsQdDELJZgMZ4dqMbm60c1J9owskPOICRtkQjKEcderKYbJW6flglSYcWO3T7WZxAq+3ceMzEGPRDjsgVeQn/EzkdU9ct0dz+Tky096Q9OnEcYx2GQTrCcndKUWvozSOmJK34hlOY4HOyyjB811z7TSTJWVeEaplxFzDFxxndjR7N+eJIig3mYxUacEnGZrqhcghrzveZkvwiEyhmO64mQQXu4wpmZXT1NIzJGPIxCofQrvnsTczxMCZLZIK6RTSZ2V2S0OBw7JfF3y3qURZkkhb1ZNqFNs13H6ACOUElaRmELXitaUM9UlcgL6gkLf2xAS2atp5gSZBJWgpRiSYpXOzxC6NTTTLi82KhyrkzmI6LDufVM36cl4XU75iPGyh3W5xTbTDXx+TUgr4d8zSf+YGWIHpyBq6i3pDgXSzE22z25CRswzLDj72DY7ju9UJek9yLnVJwuMUtHMXtdG+VlySHYodLgr24Jj13z6/B7iXJUnl7tCd3Dofx0u/lwsvE6XY5rhIfkIlKzUuSbTKb7Yv0cjxCHcr8XIO9NKSeKouxEs0O52fLj2iQKj4/00Wv6dldgGq80LTRjHVShARaBRVhrSFZVc5tdWgv61WQSrbGULK9wz6MSCjzspqkPdnnmrbb5b1pGjqCSDKxvqwxDIMul9ozpXoyne0+tRKcxGTZXHjm8JkC00MlYliG8mT3wo9i+DSmYjWaUl0nP2nOF/q8paLqyfNSuat1tjGZL6ndrYNSMLjFK6yXJ43n5Rhf0e7QSUuxSepSp+hQg3swWpPYWetLQ69M0AaXtVJ11iLZWLDH5/Cf7d6/G6O1mpck06ZSMpEjY1y18xRr5C7ZY670rDXMYr8FGABL9Zhm20Q1rQAAAABJRU5ErkJggg=="
                    alt="" style="">
                </div>
                <p>前坤环境建设集团有限公司</p>
              </li>
            </ul>
          </div>
          <div class="main-center" :style="{ display: istrue === '02' ? 'block' : 'none' }">

            <h4>大数据平台解决方案</h4>
            <p>客户案例</p>
            <ul class="main5-r-center-1">
              <li>
                <div class="main5-r-img">
                </div>
                <p>温州市公安局瓯海区分局</p>
              </li>
              <li>
                <div class="main5-r-img">
                </div>
                <p>瑞安市公安局</p>
              </li>
              <li>
                <div class="main5-r-img">
                </div>
                <p>温州市公安局鹿城区分局</p>
              </li>
              <li>
                <div class="main5-r-img">
                </div>
                <p>平阳县公安局</p>
              </li>
              <li>
                <div class="main5-r-img">
                </div>
                <p>苍南县公安局</p>
              </li>
              <li>
                <div class="main5-r-img">
                </div>
                <p>无锡市公安局</p>
              </li>
            </ul>
          </div>
          <div class="main-center" :style="{ display: istrue === '03' ? 'block' : 'none' }">
            <h4>智慧教育一体化平台解决方案</h4>
            <p>客户案例</p>
            <ul class="main5-r-center-1">
              <li>
                <div class="main5-r-img">
                  <img src="../../assets/images/首页切图/解决方案/图层530.png" alt="">
                </div>
                <p>温州市教育局</p>
              </li>
              <li>
                <div class="main5-r-img">
                  <img src="../../assets/images/首页切图/解决方案/温州市教育考试院.png" alt="">
                </div>
                <p>温州市教育考试院</p>
              </li>
              <li>
                <div class="main5-r-img">
                  <img src="../../assets/images/首页切图/解决方案/瓯海区教育局拷贝.png" alt="">
                </div>
                <p>温州市瓯海区教育局</p>
              </li>
              <li>
                <div class="main5-r-img">
                  <img src="../../assets/images/首页切图/解决方案/苍南县教育局.png" alt="">
                </div>
                <p>苍南县教育局</p>
              </li>
              <li>
                <div class="main5-r-img">
                </div>
                <p>乐清市教育局</p>
              </li>
              <li>
                <div class="main5-r-img">
                  <img src="../../assets/images/首页切图/解决方案/图层528.png" alt="">
                </div>
                <p>瓯海职业中专集团学校</p>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <div class="footer">
      <div class="relation centre">
        <img class="footer_title" src="../../assets/images/首页切图/底部/精致与实用本不矛盾.png" alt="" />
        <h2><i></i><i></i></h2>
        <div class="relation_l">
          <div class="relation_l_top">
            <img src="../../assets/images/首页切图/底部/logo.png" alt="">
          </div>
          <h3>温州掌网信息技术有限公司</h3>
          <div style="margin-left: -13px"><i class="el-icon-location-outline"></i>浙江省温州市鹿城区车站大道11号高联大厦1608室<i
              class="el-icon-phone-outline" style="width: 14px; height: 14px;"></i>400-051-0806</div>
          <p class="beian"><a href=“https://beian.miit.gov.cn/” target=“_blank”>备案号:浙ICP备13031672</a></p>
          <div class="line"></div>
        </div>
        <div class="relation_r">
          <ul>
            <li @click="() => { this.$router.push({ path: 'index' }); this.$store.commit('saveIndex', 0) }">首页</li>
            <li @click="() => { this.$router.push({ path: 'visibilization' }); this.$store.commit('saveIndex', 3) }">
              域贝可视化
            </li>
            <li @click="() => { this.$router.push({ path: 'productservice' }); this.$store.commit('saveIndex', 1) }">
              域贝电子证书</li>
            <li @click="() => { this.$router.push({ path: 'integrated' }); this.$store.commit('saveIndex', 2) }">域贝一体化
            </li>

            <li @click="() => { this.$router.push({ path: 'data' }); this.$store.commit('saveIndex', 6) }">域贝大数据</li>
            <li @click="() => { this.$router.push({ path: 'cooperation' }); this.$store.commit('saveIndex', 4) }">解决方案
            </li>
            <li @click="() => { this.$router.push({ path: 'about' }); this.$store.commit('saveIndex', 5) }">关于我们</li>
          </ul>
        </div>
        <div class="relation_logo">
          <img src="../../assets/images/首页切图/底部/二维码.png" alt="">
          <p>扫描二维码<br><br>关注我们</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Counto from 'vue-count-to'
export default {
  props: {
    // userlist: {
    //   type: Object ,
    //   required: true
    // }
  },
  components: { Counto },
  data() {
    return {
      startVal: 0,
      endVal1: 50,
      endVal2: 200,
      endVal3: 100,
      list: [{
        tlite: '01',
        text: '政企'
      },
      {
        tlite: '02',
        text: '公安'
      },
      {
        tlite: '03',
        text: '教育'
      }],
      search: "",
      origin: '',
      istrue: '01',
      liIndex: 0,
      whiteShow1: true,
      whiteShow2: true,
      whiteShow3: true,
      whiteShow4: true,
      whiteShow6: true,
      scroll: '',
      delayShow: false,
    };
  },
  mounted() {
    // canvas
    var ctx = document.getElementById('canvas').getContext('2d');
    var percent = 0;
    var data = {
      start: [500, 600],
      point: [-430, 200],
      end: [1000, 110]
    }
    function init() {
      // percent = 0; // 每次重置进程
      draw();
    }
    function draw() {
      ctx.clearRect(0, 0, 1500, 750); // 每次清除画布
      // ctx.strokeStyle = '#ffffff'; // 设置线条样式
      ctx.strokeStyle = createLinearGradient(data.start, data.end, '#fff', 'rgba(255,255,255,0)');
      drawCurvePath(data.start, data.point, data.end, percent);
      percent += 0.8; // 进程增加,这个控制动画速度
      if (percent <= 100) { // 没有画完接着调用,画完的话重置进度
        requestAnimationFrame(draw);
      } else {
        // init()
      }
    }
    function drawCurvePath(start, point, end, percent) {
      ctx.beginPath(); // 开始画线
      ctx.moveTo(start[0], start[1]); // 画笔移动到起点
      for (var t = 0; t <= percent / 100; t += 0.005) {
        // 获取每个时间点的坐标
        var x = quadraticBezier(start[0], point[0], end[0], t);
        var y = quadraticBezier(start[1], point[1], end[1], t);
        ctx.lineTo(x, y); // 画出上个时间点到当前时间点的直线
      }
      ctx.stroke(); // 描边
    }
    function quadraticBezier(p0, p1, p2, t) {
      var k = 1 - t;
      return k * k * p0 + 2 * (1 - t) * t * p1 + t * t * p2;
    }
    function createLinearGradient(start, end, startColor, endColor) {
      var lineGradient = ctx.createLinearGradient(...start, ...end);
      lineGradient.addColorStop(0, startColor);
      // lineGradient.addColorStop(0.3, '#fff');
      lineGradient.addColorStop(1, endColor);
      return lineGradient
    }
    setTimeout(() => {
      init()
    }, 1800)

  },
  created() {

  },
  methods: {
    clickadmin5(val) {
      this.istrue = val.tlite
      val.tlite === '01' ? this.liIndex = 0 : val.tlite === '02' ? this.liIndex = 1 : this.liIndex = 2
    },
    showImg(index) {
      switch (index) {
        case 1:
          this.whiteShow1 = false
          break;
        case 2:
          this.whiteShow2 = false
          break;
        case 3:
          this.whiteShow3 = false
          break;
        case 4:
          this.whiteShow4 = false
          break;
        case 6:
          this.whiteShow6 = false
          break;
      }
    },
    showImg2(index) {
      switch (index) {
        case 1:
          this.whiteShow1 = true
          break;
        case 2:
          this.whiteShow2 = true
          break;
        case 3:
          this.whiteShow3 = true
          break;
        case 4:
          this.whiteShow4 = true
          break;
        case 6:
          this.whiteShow6 = true
          break;
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      console.log(this.scroll + window.screen.height)
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
};
</script>

<style lang="less" scoped>
.el-button {
  background: transparent;
}

.header_lunbotu {
  width: 100vw;
  height: 802px;
  // background-color: pink
  background-image: url('../../assets/images/首页切图/首图/bg3.png');
  background-size: 100% 100%;
  // background-size: 1940px 802px;
  overflow: hidden;
  opacity: 0;
  animation: intoIndex 1s forwards;

  .centre {
    opacity: 0;
    animation: intoIndex 1.5s forwards;
    animation-delay: 1.5s;
  }

  .ban {
    position: relative;
    float: right;
    height: 520px;
    top: -200px;
    // margin-right: 50px;
    right: 370px;
    opacity: 0;
    animation: intoIndex 1.5s forwards;
    animation-delay: .5s;
    z-index: 4;
  }

  #canvas {
    position: absolute;
    top: 150px;
    right: 20px;
    // border: 1px solid #ccc;
    // background: #0f1632;
    z-index: 1;
  }

  .block_1 {
    position: relative;
    float: right;
    top: 0px;
    // margin-right: -700px;
    right: -100px;
    opacity: 0;
    width: 260px;
    height: 260px;
    z-index: 10;
    animation: move1 4s infinite linear,
      intoIndex 2s forwards 1s;
  }

  .block_2 {
    position: relative;
    float: right;
    top: 120px;
    // margin-right: -160px;
    right: 150px;
    opacity: 0;
    width: 100px;
    height: 100px;
    z-index: 10;
    animation: move2 3s infinite linear,
      intoIndex 2s forwards 1s;
  }

  .circle_1 {
    position: absolute;
    top: 150px;
    left: 900px;
    opacity: 0;
    animation: shink 3s infinite;
  }

  .circle_2 {
    position: absolute;
    top: 180px;
    left: 300px;
    opacity: 0;
    transform: rotate(240deg);
    animation: shink 3.5s infinite;
  }

  .circle_3 {
    position: absolute;
    top: -30px;
    left: 650px;
    opacity: 0;
    transform: rotate(70deg);
    animation: shink 4.5s infinite;
  }

  .meteor_1 {
    position: absolute;
    top: 20px;
    left: 20px;
    transform: rotate(180deg);
  }

  .meteor_2 {
    position: absolute;
    top: 0px;
    left: 800px;
  }

  // 流星
  .star_box {
    position: absolute;
    top: 50px;
    left: 300px;
    // background: #23405a;
    width: 50%;
    height: 50%;
    transform: rotateZ(45deg);
  }

  .star {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 1px;
    width: 0px;
    background: linear-gradient(-45deg, rgba(255, 255, 255, .5), rgba(0, 0, 255, 0));
    border-radius: 999px;
    filter: drop-shadow(0 0 6px #ffffff);
    animation: tail 3s ease-in-out infinite,
      falling 3s ease-in-out infinite;
  }

  @keyframes tail {
    0% {
      width: 0px;
    }

    50% {
      width: 150px;
    }

    100% {
      width: 0px;
    }
  }

  @keyframes falling {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(600px);
    }
  }

  .star:nth-child(1) {
    top: calc(50% - 700px);
    left: calc(50% - 50px);
    animation-delay: 2s;
  }

  .star:nth-child(2) {
    top: calc(50% - 600px);
    left: calc(50% - 0px);
    animation-delay: 1.6s;
  }

  .star:nth-child(3) {
    top: calc(50% - 400px);
    left: calc(50% - 250px);
    animation-delay: 2.1s;
  }

  .star:nth-child(4) {
    top: calc(50% - 100px);
    left: calc(50% - 600px);
    animation-delay: 1s;
  }

  .star:nth-child(5) {
    top: calc(50% + 100px);
    left: calc(50% - 600px);
    animation-delay: 1.2s;
  }
}

@keyframes intoIndex {
  0% {
    opacity: 0;
  }

  50% {
    opacity: .5;
  }

  100% {
    opacity: 1;
  }
}

@keyframes move1 {
  0% {
    top: 0px;
  }

  50% {
    top: -50px;
  }

  100% {
    top: 0px;
  }
}

@keyframes move2 {
  0% {
    top: 110px;
  }

  50% {
    top: 60px;
  }

  100% {
    top: 110px;
  }
}

@keyframes shink {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.header_lunbotu h3 {
  font-weight: 500;
  font-size: 40px;
  color: #fff;
  padding: 300px 0 0 52px;
  overflow: hidden;
}

.centre {
  width: 1240px;
  margin: 0 auto;
}

.dynamic {
  // line-height: 30px;
  background: #f4f4f7;
  padding: 98px 0 138px 0;
}

.yxb {
  background: #f9f9f9;
  padding: 100px 0;
}

h2 {
  margin-bottom: 23px;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333;
}

.main_header div {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #676a7f;
}

.main_bimg {
  float: left;
  width: 430px;
  height: 430px;
  // background-color: #2170de;
  // height: 718px;
  margin-top: 20px;
  margin-left: 70px;
  position: relative;
  overflow: hidden;

  .back_clrcle {
    position: absolute;
    z-index: 1;
    // background: #2170de;
    border-radius: 50%;
  }

  .main_img {
    position: absolute;
    margin-top: 40px;
    margin-left: 20px;
    z-index: 2;
  }

  .mainblock_1 {
    position: absolute;
    margin-top: 210px;
    margin-left: 105px;
    animation: blockmove1 4s infinite;
    opacity: .9;
    z-index: 3;
  }

  .diban {
    position: absolute;
    margin-top: 135px;
    margin-left: 30px;
    z-index: 2;
  }

  .houban {
    position: absolute;
    margin-top: 50px;
    margin-left: 110px;
    z-index: 3;
  }

  .mainblock_2 {
    position: absolute;
    margin-top: 80px;
    margin-left: 265px;
    animation: blockmove2 3.8s infinite;
    opacity: .9;
    z-index: 3;
  }

  .paper {
    position: absolute;
    top: 225px;
    left: 201px;
    animation: papermove 2s infinite linear;
    // opacity: .9;
    z-index: 2;
  }

  .zhezhao {
    position: absolute;
    z-index: 5;
    top: 222px;
    left: 243px;
  }

  .paper_1 {
    position: absolute;
    margin-top: 230px;
    margin-left: 225px;
    // animation: papermove 3s infinite;
    opacity: .5;
    z-index: 34;
  }
}

@keyframes blockmove1 {
  0% {
    margin-top: 210px;
  }

  50% {
    margin-top: 160px;
  }

  100% {
    margin-top: 210px;
  }
}

@keyframes blockmove2 {
  0% {
    margin-top: 80px;
  }

  50% {
    margin-top: 40px;
  }

  100% {
    margin-top: 80px;
  }
}

@keyframes papermove {
  0% {
    // opacity: .9;
    top: 225px;
    left: 201px;
  }

  25% {
    // opacity: .9;
  }

  50% {
    // opacity: .9;
    // margin-top: 260px;
    // margin-left: 265px;
  }

  75% {
    // opacity: .4;
  }

  100% {
    // opacity: 0;
    top: 262px;
    left: 255px;
  }
}

.main_b2 {
  height: 716px;
}

// .main_bimg img {
//   width: 491px;
//   height: 513px;
// }
.main_bimg2 img {
  width: 521px;
  height: 472px;
}

.main_btext {
  float: left;
  margin-left: 130px;
  margin-top: -90px;
}

.btext {
  margin-top: 30px;
  width: 560px;
  height: 220px;
  text-align: left;

  .el-button:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
  }
}

.btext button {
  width: 129px;
  height: 46px;
  margin-top: 36px;
}

.btext p {
  text-indent: 2em;
  font-size: 16px;
  width: 530px;
  // color: #475d73;
  line-height: 25px;
}

.index_main1 {
  // position: relative;
  height: 720px;
  opacity: 1;

  // animation: shink 3s infinite;
  // background-image: url('../../assets/images/首页切图/电子证书/电子证书bg.png');
  .bottom_img {
    position: absolute;
    width: 100%;
    z-index: -1;
    animation: shink 2s infinite;
  }
}

.index_main1 .zheng {
  // position: absolute;
  right: 0;
  bottom: 0;
  transform: translate(-228px, 50px);

}

.main_b h3 {
  margin-bottom: 10px;
}

.main_btext h3 {
  margin-top: 196px;
  margin-left: 0px;
  font-size: 36px;
  font-weight: 500;
  color: #23405a;
}

a {
  text-decoration: none;
}

.index_main2 .centre {
  text-align: center !;
  width: 1200px;
}

.index_main2 {
  padding-top: 54px;
  height: 644px;
  background-color: #f4fbfe;
}

.main2-center {
  margin-top: 42px;
  text-align: center;

  .el-button:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
  }
}

.index_main2 h3 {
  font-weight: normal;
  margin-bottom: 30px;
  // margin-top: 54px;
  font-size: 36px;
  // text-align: center;
  color: #23405a;
}

.index_main2 p {
  margin-bottom: 30px;
  font-size: 16px;
}

.index_main2 button {
  width: 129px;
  height: 46px;
}

li {
  list-style: none;
}

.index_main2 ul {
  margin-top: 30px;
  display: flex;
  justify-content: center;

}

.index_main2 ul li {
  width: 224px;
  height: 241px;
  float: left;
  margin-right: 20px;
  text-align: center;
  border-radius: 4px;
  box-shadow: 2px 5px 7px 2px rgba(0, 0, 0, .05);
  background-color: white;
  transition: all 1s linear;

  &:hover {
    box-shadow: 1px 2px 8px 4px rgba(0, 0, 0, .18);

    .amin2-img-top {
      transform: translate(-23px, -50px);
    }

    p {
      color: #3186fd;
    }
  }
}

.index_main2 ul li:last-child {
  margin-right: 0px;
}

.main2-img {
  position: relative;
  margin-left: 50px;
  width: 131px;
  height: 101px;
  margin-top: 44px;
  margin-bottom: 30px;
}

.amin2-img-top {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-23px, -28px);
  transition: all .2s linear;
}

.index_main2 ul li p {
  font-size: 18px;
  color: #23405a;
}

.index_main3 {
  height: 670px;
  padding-top: 44px;
  display: flex;
  justify-content: center;
  // background-color: #3186fd;
}

.index_main3 .main3-l h3 {
  margin-top: 274px;
  font-weight: normal;
  margin-bottom: 30px;
  margin-top: 90px;
  font-size: 36px;
  color: #23405a;
  // font-family: PingFangSC-Semibold, sans-serif;
}

.main3-l {
  float: left;
  margin-top: 90px;
}

.main3-r {
  width: 500px;
  height: 500px;
  // background: #2170de;
  margin-top: 60px;
  float: left;

  .back {
    position: absolute;
    margin-top: -80px;
    margin-left: 120px;
    z-index: 10;
  }

  .bottom {
    position: absolute;
    margin-top: 150px;
    margin-left: 30px;
    z-index: 1;
  }

  .bottom_block {
    position: absolute;
    margin-top: 257px;
    margin-left: 190px;
    z-index: 2;
    opacity: 0;
    animation: shink 5s infinite;
  }

  .move_box {
    position: absolute;
    width: 0px;
    height: 70px;
    transform: rotate(-30deg);
    background-color: rgb(255, 255, 255);
    margin-top: 290px;
    margin-left: 160px;
    z-index: 3;
    // animation: move1 7s infinite;
  }

  .bottom_circle {
    position: absolute;
    margin-top: 240px;
    margin-left: 130px;
    z-index: 5;
    opacity: 0;
    animation: shink 3.5s infinite;
  }

  .big_circle {
    position: absolute;
    position: absolute;
    margin-top: 70px;
    margin-left: 133px;
    z-index: 15;
  }

  .big_cloud {
    position: absolute;
    position: absolute;
    margin-top: 200px;
    margin-left: 230px;
    animation: zmove1 3s infinite ease-in-out;
    z-index: 15;
  }
}

@keyframes zmove1 {
  0% {
    margin-top: 200px;
    // margin-top: 290px;
    // margin-left: 160px;
  }

  50% {
    margin-top: 170px;
    // margin-top: 145px;
    // margin-left: 400px;
  }

  100% {
    margin-top: 200px;
    // margin-top: 290px;
    // margin-left: 160px;
  }
}

.main4-l {
  float: left;
  margin-left: 84px;
  margin-right: 20px;
  position: relative;
  width: 343px;
  height: 488px;
  background: url('../../assets/images/首页切图/大数据/pic.png');
  padding: 30px 18px;

  .content_1 {
    position: relative;
    top: 150px;
    opacity: 0;
    transition: 1s;

    p {
      font-size: 18px;
      line-height: 40px;
      color: white;
    }
  }

  &:hover {
    .content_1 {
      top: 30px;
      opacity: 1;
    }

    img {
      opacity: 0;
    }
  }
}

.index_main4 {
  height: 488px;
  margin-bottom: 604px;
}

.index_main4 h3 {
  font-weight: normal;
  font-size: 26px;
  color: #dceffc;
}

.index_main4 p {
  font-weight: normal;
  font-size: 14px;
  margin-top: 18px;
  color: #dceffc;
}

.main4-l img {
  position: absolute;
  bottom: 30px;
  right: 18px;
  width: 136px;
  height: 133px;
  transition: .8s;
}

.main4-r {
  float: left;
  width: 725px;
  margin-right: 20px;
  margin-bottom: 114px;
}

.main4-r ul li {
  float: left;
  width: 343px;
  height: 234px;
  margin-bottom: 20px;
  // background-color: pink;
  padding: 30px 30px 30px 20px;
}

.main4-r ul li:first-child {
  background: url('../../assets/images/首页切图/大数据/pic1.png');
}

.main4-r ul li:nth-child(2) {
  background: url('../../assets/images/首页切图/大数据/pic2.png');
}

.main4-r ul li:nth-child(3) {
  background: url('../../assets/images/首页切图/大数据/pic3.png');
}

.main4-r ul li:last-child {
  background: url('../../assets/images/首页切图/大数据/pic4.png');
}

.main-centre {
  margin-right: 20px;

}

.main-centre,
.main-centre-right {
  &:hover {
    .main4-text {
      margin-top: 30px;
      opacity: 1;
    }

    .main4-img {
      opacity: 0;
    }
  }
}

.index_main4 h3 {
  font-weight: normal;
  font-size: 22px;
  color: #dceffc;
}

.index_main4 p {
  font-weight: normal;
  font-size: 14px;
  margin-top: 18px;
  color: #dceffc;
}

.main4-img {
  // display: none;
  position: absolute;
  margin-top: 8px;
  margin-left: 165px;
  opacity: 1;
  transition: .8s;

  img {
    height: 100px;
  }
}

.main4-text {
  position: relative;
  margin-top: 100px;
  opacity: 0;
  transition: 1s;
  // margin-bottom: 18px;
}

.main4-text p {
  display: block;
  font-size: 18px;
  color: #fff;
}

.main-centre .main-centre-p {
  font-size: 12px !important;
}

.index_main5 {
  height: 670px;
  // background-color: #3186fd;
  // padding-top: 118px;
  // float: left;
}

.index_main5-l {
  float: left;
  width: 430px;
  height: 568px;
  padding-top: 244px;
  padding-left: 48px;
  margin-left: 10px;
  background-image: url('../../assets/images/首页切图/解决方案/组23.png');
}

.index_main5-l h3 {
  font-weight: normal;
  font-size: 32px;
  color: #23405a;
  margin-bottom: 24px;

}

.index_main5-l p {
  font-size: 32px;
  color: #475d73;
}

.index_main5-r {
  width: 770px;
  background-image: url('../../assets/images/首页切图/解决方案/组22.png');
  height: 568px;
  padding-top: 52px;
  padding-left: 42px;
  float: left;

  .el-button {
    &:hover {
      background-color: #fff;
      color: #3186fd;
    }
  }
}

.index_main5-r .index_main5-r-1 {
  width: 430px;
}

.index_main5-r .index_main5-r-1 .li_1 {
  float: left;
  height: 60px;
  width: 140px;
  border-bottom: 2px solid #76afff;

  &:hover {
    .text {
      font-size: 20px;
    }
  }
}

.index_main5-r .index_main5-r-1 li .tlite {
  font-size: 16px;
  color: #fff;
  margin-bottom: 7px;
}

.index_main5-r .index_main5-r-1 li .text {
  font-size: 16px;
  color: #fff;
}

.index_main5-r .index_main5-r-1 .li_2 {
  float: left;
  height: 60px;
  width: 140px;
  border-bottom: 2px solid #fff;

  .text {
    font-size: 20px;
  }
}

.lse {
  border-bottom: 5px solid #fff !important;
}

.index_main5-r button {
  width: 129px;
  height: 46px;
  background-color: rgba(255, 255, 255, 0);
  color: #fff;
  margin-left: 120px;
}

.main-center h4 {
  font-weight: normal;
  font-size: 16px;
  color: #cad9ff;
  margin-top: 28px;
}

.main-center p {
  font-weight: normal;
  font-size: 16px;
  color: #fff;
  margin-top: 28px;
  margin-bottom: 20px;
}

.index_main5-r .main-center ul {
  width: 632px;
}

.index_main5-r .main-center ul li {
  float: left;
  margin-right: 40px;
  width: 276px;
  height: 89px;
  border-radius: 4px;
  margin-bottom: 24px;
  border: 1px solid #cad9ff;
  display: flex;
  justify-content: center;

  // cursor: pointer;
  &:hover {
    background-color: #fff;

    p {
      color: #3186fd;
    }
  }
}

.index_main5-r .main-center ul li .main5-r-img {
  float: left;
  width: 40px;
  height: 40px;
  // background-color: #fff;
  margin-top: 10px;

  // margin-left: 12px;
  img {
    height: 35px;
  }
}

.index_main5-r .main-center ul li p {
  width: 170px;
  float: left;
  margin-top: 34px;
  margin-left: 5px;
  font-size: 14px;
}

.main5-r-center-2,
.main5-r-center-3 {
  display: none;
}

// 数据
.heder-bottom {
  // position: absolute;
  transform: translateY(-160px);
  width: 1200px;
  height: 160px;
  background-color: #fff;
  padding: 38px 70px;
  box-shadow: 0 2px 27px 2px rgba(0, 0, 0, .15);
  border-radius: 4px;
  opacity: 0;
  animation: identifier 1s forwards;
  animation-delay: 1.3s;
}

@keyframes identifier {
  0% {
    transform: translateY(-100px);
    opacity: 0;
  }

  100% {
    transform: translateY(-160px);
    opacity: 1;
  }
}

.heder-bottom ul li {
  float: left;
  display: block;
  width: 30%;
}

.heder-bottom ul li:nth-child(2) {
  margin-left: 50px;
}

.heder-bottom ul li:last-child {
  margin-left: 40px;
}

.heder-bottom-l {
  float: left;
  width: 73px;
  height: 84px;
  background-color: #fff;
  color: #000;
  margin-right: 18px;

  .center_img {
    position: relative;
    top: -65px;
    left: 15px;
    transition: 1s;
  }

  &:hover {
    .center_img {
      transform: rotate(360deg);
    }
  }
}

.heder-bottom-r {
  float: left;
}

.heder-bottom-r .date-1 {
  font-size: 36px;
  color: #405970;
}

.heder-bottom-r i {
  position: relative;
  top: -20px;
  font-size: 20px;
}

.heder-bottom-r h3 {
  font-weight: normal;
  font-size: 14px;
  margin-top: 10px;
  color: #475d73;
}

.footer {
  // background-color: ;
  background-image: url('../../assets/images/首页切图/底部/底部bg.png');
  height: 563px !important;
  padding-top: 170px;
  padding-left: 88px;
  z-index: -111;
}

.relation h2 {
  text-align: center;
  font-size: 36px;
  color: #fff;
  -webkit-transform: skew(-10deg);
  /* for Chrome||Safari */
  -ms-transform: skew(-10deg);
  /* for IE */
  -moz-transform: skew(-10deg);
  /* for Firefox */
  -o-transform: skew(-10deg);
  /* for Opera */
  letter-spacing: 6px;
  margin-bottom: 59px;
}

.footer_title {
  position: relative;
  left: 430px;
}

.relation h2 i {
  font-size: 20px;
  margin: 8px 0;
}

.relation_l {
  float: left;
}

.relation_l .relation_l_top {
  height: 55px;
  width: 200px;
  // background-color: pink;
  // background-image: url('../assets/images/首页切图/首图/bg2.png');
  margin-bottom: 52px;
}

.relation_l .line {
  position: absolute;
  width: 56%;
  height: 1px;
  margin-top: -30px;
  // margin-left: 10%;
  background: #f0f0f0;
  opacity: 0.5;
}

.relation_l h3 {
  font-size: 18px;
  color: #fff;
  font-weight: normal;
  margin-bottom: 20px;
}

.relation_l div {
  color: #fff;
  font-size: 14px;
  margin-bottom: 78px;
}

.relation_l div i {
  margin: 0 12px;
}

.beian {
  font-size: 12px;
  color: #fff;
  text-decoration: none;
}

.relation_r {
  float: left;
  margin-left: 200px;
}

.relation_r ul li {
  font-size: 14px;
  color: #fff;
  margin-bottom: 15px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.relation_logo {
  float: left;
  margin-left: 166px;
  width: 108px;
  text-align: center;
}

.relation_logo img {
  width: 108px;
  height: 108px;
  background-color: pink;
}

.relation_logo p {
  margin-top: 20px;
  color: #fff;
  display: inline-block;
  font-size: 16px;
  // background-image: url('../../assets/images/首页切图/底部/地址.png');
}

@media (max-width: 1300px) {
  .header_lunbotu {
    .ban {
      position: relative;
      float: right;
      height: 590px;
      top: -200px;
      right: 200px;
      opacity: 0;
      animation: intoIndex 1.5s forwards;
      animation-delay: .5s;
      z-index: 3;
    }

    #canvas {
      position: absolute;
      top: 150px;
      right: -80px;
      z-index: 1;
    }

    .block_1 {
      position: relative;
      float: right;
      top: 0px;
      left: 260px;
      opacity: 0;
      width: 260px;
      height: 260px;
      z-index: 10;
      animation: move1 4s infinite linear,
        intoIndex 2s forwards 1s;
    }

    .block_2 {
      position: relative;
      float: right;
      top: 120px;
      left: 40px;
      opacity: 0;
      width: 100px;
      height: 100px;
      z-index: 10;
      animation: move2 3s infinite linear,
        intoIndex 2s forwards 1s;
    }
  }
}
</style>
